import { css } from 'lit';

export const chatbotMessageStyles = css`
    :host {
        position: relative;
        .button-container {
            display: flex;
            flex-wrap: wrap;
            gap: 0.5rem;
            margin-top: 0.5rem;
        }
    }
`;
